import Nullstack from 'nullstack';
export default function IconSoup({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-soup",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 11h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1z"
  }), "   ", Nullstack.element("path", {
    d: "M12 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
  }), "   ", Nullstack.element("path", {
    d: "M16 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
  }), "   ", Nullstack.element("path", {
    d: "M8 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
  }), " ");
}